import React, { Component } from 'react';

import './styles/modalClubLoanInfo.scss';
import {separate} from "../../../helpers/separate";

export default class ModalClubLoanInfo extends Component {
  render() {
    return (
      <div className="club-loan-info">
        <p>Подробную информацию об условиях рассрочки от клуба вы сможете увидеть на шаге 3 при оформлении - на странице оплаты.</p>
      </div>
    )
  }
}